import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../../AppContext';

const Intro = () => {
    const { appState } = useContext(AppContext);
    const { intro } = appState;
    const { items } = intro || {};

    const [expandedIndex, setExpandedIndex] = useState(null);

    if (!items?.[0]) return null;

    return (
        <section className="genmed-intro">
            <div className="container">
                <div className="row justify-content-center">
                    {items.map((item, i) => {
                        const isExpanded = expandedIndex === i;
                        return (
                            <div key={i} className="col-lg-3 col-sm-6 d-flex">
                                <div
                                    className={`intro-box bg-dark-brown ${item.resClass}`}
                                    style={{
                                        background: 'linear-gradient(to bottom, #003366, #007BFF)',
                                        color: 'white',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <div className="intro-wrapper text-center" style={{ flexGrow: 1, maxHeight: 230 }}>
                                        {item.icon && <i
                                            className={item.icon || "fas fa-flag"}
                                            style={{ fontSize: 30, marginBottom: 8 }}
                                        />}
                                        <h6 className="text-custom-white fw-700" style={{ fontSize: 16, marginBottom: 8 }}>
                                            {item.title}
                                        </h6>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'baseline',
                                                marginBottom: 8,
                                            }}
                                        >
                                            <h3 className="text-custom-white" style={{ fontSize: 28, margin: 0 }}>
                                                {item.rate || '35%'}
                                            </h3>
                                            <span style={{ fontSize: 12, marginLeft: 4 }}>{item?.metric || 'APR'}</span>
                                        </div>
                                        <p
                                            className="text-custom-white"
                                            style={{
                                                maxHeight: isExpanded ? 'none' : '4.5em',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: isExpanded ? 'unset' : 3,
                                                WebkitBoxOrient: 'vertical',
                                                fontSize: 14,
                                                lineHeight: 1.4,
                                                marginBottom: 6,
                                            }}
                                        >
                                            {item.text}
                                        </p>

                                        {item.text?.length > 65 && (
                                            <button
                                                className="text-custom-white"
                                                onClick={() => setExpandedIndex(isExpanded ? null : i)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    fontSize: 12,
                                                    color: '#fff',
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline',
                                                    marginBottom: 8,
                                                }}
                                            >
                                                {isExpanded ? 'Show less' : 'Read more'}
                                            </button>
                                        )}
                                    </div>

                                    <Link
                                        onClick={() => {
                                            setTimeout(() => {
                                                item?.link && window.open(item?.link, '_self');
                                            }, 100);
                                        }}
                                        className="btn-first btn-submit fw-600"
                                        style={{
                                            border: '1px solid white',
                                            padding: '6px 12px',
                                            fontSize: 14,
                                            textAlign: 'center',
                                            color: 'white',
                                            textDecoration: 'none',
                                            marginTop: 10,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {item?.buttonText || 'Apply Now'}
                                    </Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Intro;
